import React from 'react';
import { Link } from 'react-router-dom';
import IngestionHistory from './sections/IngestionHistory';
import POSConnection from './sections/POSConnection';
import Schedule from './sections/Schedule';
import CategoriesMapping from './sections/CategoriesMapping';
import ProductMapping from './sections/ProductMapping';
import Rules from './sections/rules';

// Rules is deliberately not here: a marketplace store's rules live in the CDC
// pipeline and have nothing to do with a POS connection. The section decides for
// itself which surface to render, and LeftNav already leaves the tab enabled.
const TABS_REQUIRING_POS = ['categories-mapping', 'product-mapping'];

const PosRequiredPlaceholder = ({ tabLabel }) => (
  <div className="p-8 w-full">
    <div className="bg-white dark:bg-theme-surface-accent border border-slate-200 dark:border-slate-700 rounded-lg p-8 text-center max-w-md mx-auto">
      <p className="text-slate-600 dark:text-slate-400 mb-4">
        Connect a POS system to use {tabLabel}.
      </p>
      <Link
        to="/external-feeds/pos"
        className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
      >
        Go to POS Connection
      </Link>
    </div>
  </div>
);

const TAB_LABELS = {
  'categories-mapping': 'Categories Mapping',
  'product-mapping': 'Product Mapping',
};

const Settings = ({ selected, hasPosConnection, posCheckLoading, onPosConnectionChange }) => {
  const requiresPos = TABS_REQUIRING_POS.includes(selected);
  const showPlaceholder = requiresPos && !posCheckLoading && !hasPosConnection;

  if (showPlaceholder) {
    return <PosRequiredPlaceholder tabLabel={TAB_LABELS[selected]} />;
  }

  switch (selected) {
    case 'ingestion-history':
      return <div className="p-8 w-full"><IngestionHistory /></div>;
    case 'pos':
      return (
        <div className="p-8 w-full">
          <POSConnection onPosConnectionChange={onPosConnectionChange} />
        </div>
      );
    case 'schedule':
      return <div className="p-8 w-full"><Schedule /></div>;
    case 'categories-mapping':
      return <div className="p-8 w-full"><CategoriesMapping /></div>;
    case 'product-mapping':
      return <div className="p-8 w-full"><ProductMapping /></div>;
    case 'rules':
      return (
        <div className="p-8 w-full">
          <Rules hasPosConnection={hasPosConnection} />
        </div>
      );
    default:
      return null;
  }
};

export default Settings;